(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mm-back-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mm-back-button]');
    if (!button) return;

    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mm-faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.mm-faq-item__trigger');
    if (!trigger) return;

    var item = trigger.closest('.mm-faq-item');
    var list = trigger.closest('.mm-faq__list');
    if (!item || !list) return;

    // mm: toggle real — si la pregunta en la que se dio clic ya estaba
    // abierta, se cierra y no queda ninguna abierta. Si estaba cerrada,
    // se abre esa y se cierran las demás (solo una abierta a la vez).
    var wasOpen = item.classList.contains('is-open');

    list.querySelectorAll('.mm-faq-item').forEach(function (i) {
      i.classList.remove('is-open');
      var t = i.querySelector('.mm-faq-item__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });

    if (!wasOpen) {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
